/**
 * Created by james on 8/5/14.
 */
'use strict';

var loader = require('helpers/loader');
var dibs = require('libraries/dibs');

// JS to include for all dealer pages
require('libraries/qualaroo');
require('libraries/browserModal');

// ---------------------------------------------------
// Module Definition

/**
 * @module dealerLoader
 * @type {Function}
 */
var dealerLoader = (module.exports = function() {
    return dealerLoader.getInstance();
});

// ---------------------------------------------------
// Module Static Properties

/**
 * Returns singleton of loader class instance
 * @memberOf dealerLoader
 */
dealerLoader.getInstance = function() {
    if (!dealerLoader._instance) {
        dealerLoader._instance = new dealerLoader.DealerLoaderHelper();
    }
    return dealerLoader._instance;
};

/**
 * @memberOf dealerLoader
 * @class dealerLoader.DealerLoaderHelper
 * @extends loader.LoaderHelper
 */
dealerLoader.DealerLoaderHelper = function() {};

dibs.protoInherit(dealerLoader.DealerLoaderHelper, loader.LoaderHelper);
